import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    title: 'Cirugía',
    description: 'Quirófanos equipados con tecnología de vanguardia para procedimientos seguros.',
    image: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=800&q=80'
  }, {
    title: 'Vacunación',
    description: 'Planes preventivos personalizados para cada etapa de su vida.',
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80'
  }, {
    title: 'Bienestar',
    description: 'Estética y cuidados integrales para mantener su salud física y emocional.',
    image: 'https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=800&q=80'
  }, {
    title: 'Urgencias',
    description: 'Atención inmediata y monitoreo avanzado las 24 horas del día.',
    image: 'https://images.unsplash.com/photo-1612531386530-97d3f37d1093?w=800&q=80'
  }];
  return <section id="servicios" className="py-24 md:py-32 bg-cream" data-id="element-95">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-20" data-id="element-97">
          <h2 className="text-4xl md:text-5xl text-matte" data-id="element-98">
            Nuestros Servicios
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-99">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} className="group cursor-pointer" data-id="element-100">
              <div className="overflow-hidden mb-6 aspect-[4/3] bg-sand/20" data-id="element-101">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" data-id="element-102" />
              </div>
              <h3 className="text-3xl text-matte mb-3" data-id="element-103">{service.title}</h3>
              <p className="text-matte/70 leading-relaxed max-w-md" data-id="element-104">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}